import React, { useState } from 'react';

import { WpToggleSwitch } from '..';

const ToggleSwitchDocs = () => {
  const [checked, setChecked] = useState(true);

  console.log('-- in docs', checked);
  return (
    <div>
      <WpToggleSwitch id="switch" label="Test switch" checked={checked} onChange={setChecked} />

      <WpToggleSwitch id="switch" label="Test switch" checked={checked} onChange={setChecked} />
    </div>
  );
};

export default ToggleSwitchDocs;
